module.exports = __webpack_public_path__ + "static/media/rom10.002ed405.jpg";